import { Method } from "../Config";
import { ResponseType, Gateway } from "./Gateway";

interface LoginQueryParams {
    id: string;
    password: string;
    platform: string;
}

interface SessionReqBody {
    properties: options[];
}

type options = "username" | "emailNotification";

class SessionGateway extends Gateway {
    protected readonly _contextPath = "session";
    protected readonly _pathParams?: { [key: string]: string };
    protected readonly _processParams = {
        login: "login",
        logout: "logout",
    };

    public async reqLogin(query: LoginQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.login,
            ...query,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqLogOut(): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.logout,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }
}

export { SessionGateway, type LoginQueryParams };
